import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import { deleterDispatchHelper } from 'actions/DeleterActions';
import { addNotification } from 'actions/NotificationsActions';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import TableResponsive from 'components/layout/TableResponsive';

import CommunityJoin from 'components/modals/CommunityJoin';
import CommunityLeave from 'components/modals/CommunityLeave';

import List from 'components/List';
import RichEditorContent from 'components/RichEditorContent';

import may from 'js/security';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class Communities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showJoin: false,
      showLeave: false,
      selectedWhiteLabel: null,
    };
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatusJoin,
      formStatusLeave,
      doNotify,
    } = this.props;

    if (prevProps.formStatusJoin.pending && !formStatusJoin.pending && !formStatusJoin.hasError) {
      this.closeJoin();
      doNotify(1, messages.you_joined_community);
    }

    if (prevProps.formStatusLeave.pending && !formStatusLeave.pending && !formStatusLeave.hasError) {
      this.closeLeave();
      doNotify(1, messages.you_left_community);
    }
  };

  showJoin = selectedWhiteLabel => {
    this.setState({ showJoin: true, selectedWhiteLabel });
  };

  closeJoin = () => {
    this.setState({ showJoin: false });
  };

  showLeave = selectedWhiteLabel => {
    this.setState({ showLeave: true, selectedWhiteLabel });
  };

  closeLeave = () => {
    this.setState({ showLeave: false });
  };

  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;

    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: null, name: messages.communities },
        ]}
        className="p-t-0"
      />
    );
  };

  render() {
    const {
      intl: { messages },
      list,
      user,
    } = this.props;
    const { showJoin, showLeave, selectedWhiteLabel } = this.state;

    const headers = {
      name: messages.name,
      description: messages.description,
      actions: messages.actions,
    };

    const rows = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const whiteLabel = list.data.list[i];
      const { name, is_member: isMember, community_description: communityDescription } = whiteLabel;

      const actions = isMember
        ? [
            <Button className="btn-rounded m-r-10" bsSize="sm" onClick={() => this.showLeave(whiteLabel)} key="leave">
              {messages.leave_community}
            </Button>,
          ]
        : [
            <Button
              className="btn-rounded m-r-10"
              bsSize="sm"
              bsStyle="primary"
              onClick={() => this.showJoin(whiteLabel)}
              key="join"
            >
              {messages.join_community}
            </Button>,
          ];

      const rowData = {
        name,
        description: <RichEditorContent content={'<div>' + communityDescription + '</div>'} />,
        actions,
      };

      rows.push(rowData);
    }

    const resultTable = list.pending ? <Loader /> : <TableResponsive headers={headers} rows={rows} />;

    return (
      <DocMeta tags={generateMetaTags(messages.meta.communities)}>
        <List
          listName="communities"
          url="/api/whitelabels.json"
          urlData={{ filters: { isCommunity: true } }}
          list={list}
          title={messages.communities}
          iconClass="fad fa-project-diagram"
          showSearch={may('ROLE_SUPERADMIN', user.roles)}
          sortOptions={['name,asc', 'cdate,desc']}
          breadcrumb={this.getBreadcrumb()}
        >
          {resultTable}

          {!!selectedWhiteLabel && (
            <React.Fragment>
              <div id="community-join">
                <CommunityJoin show={showJoin} close={this.closeJoin} whiteLabel={selectedWhiteLabel} />
              </div>
              <div id="community-leave">
                <CommunityLeave show={showLeave} close={this.closeLeave} whiteLabel={selectedWhiteLabel} />
              </div>
            </React.Fragment>
          )}
        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.communities,
    user: state.login.user,
    formStatusJoin: state.formStatus.communityJoin,
    formStatusLeave: state.formStatus.communityLeave,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteDataPush: whiteLabelId => {
      deleterDispatchHelper('whiteLabel', `/api/whitelabels/${whiteLabelId}.json`, dispatch);
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Communities)
  )
);
